export default "__VITE_ASSET__jdu0U64i__"